import React, { useEffect, useState } from 'react';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
const CheckOutForm = ({ bookingData }) => {

    const [cardError, setCardError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [transactionId, setTransactionId] = useState('');
    const [clientSecret, setClientSecret] = useState("");

    const stripe = useStripe();
    const elements = useElements();
    const { _id, productId, buyerName, buyerEmail, sellingPrice } = bookingData;

    useEffect(() => {
        // Create PaymentIntent as soon as the page loads
        fetch("https://boilagbe-com-server.vercel.app/create-payment-intent", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                authorization: `bearer ${localStorage.getItem('boilagbeToken')}`
            },
            body: JSON.stringify({ sellingPrice }),
        })
            .then((res) => res.json())
            .then((data) => setClientSecret(data.clientSecret));
    }, [sellingPrice]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!stripe || !elements) {
            return
        }

        const card = elements.getElement(CardElement);
        if (card === null) {
            return;
        }

        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card
        });

        if (error) {
            console.log(error);
            setCardError(error.message);
        }
        else {
            setCardError('');
        }
        setSuccess('');
        setLoading(true);
        const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
            clientSecret,
            {
                payment_method: {
                    card: card,
                    billing_details: {
                        name: buyerName,
                        email: buyerEmail
                    },
                },
            },
        );
        if (confirmError) {
            setCardError(confirmError.message);
            return;
        }
        if (paymentIntent.status === "succeeded") {
            console.log('card info', card);
            // store payment info in the database
            const payment = {
                sellingPrice,
                transactionId: paymentIntent.id,
                buyerEmail,
                buyerName,
                bookingId: _id,
                productId
            }
            fetch('https://boilagbe-com-server.vercel.app/payments', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    authorization: `bearer ${localStorage.getItem('boilagbeToken')}`
                },
                body: JSON.stringify(payment)
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data);
                    if (data.insertedId) {
                        setSuccess('Congratulation. Your Payment Successfull');
                        setTransactionId(paymentIntent.id);
                        toast.success('Payment Successfull');
                    }
                })
        }
        setLoading(false);

    }
    return (
        <>
            <form onSubmit={handleSubmit}>
                <div className='w-1/2'>
                    <CardElement
                        options={{
                            style: {
                                base: {
                                    fontSize: '16px',
                                    color: '#424770',
                                    height: '20px',
                                    '::placeholder': {
                                        color: '#aab7c4',
                                    },
                                },
                                invalid: {
                                    color: '#9e2146',
                                },
                            },
                        }}
                        className='border p-5 rounded-lg' />
                    <div className='flex gap-5'>
                        <button
                            className={`btn btn-sm mt-4 btn-info text-white ${loading ? 'loading' : ''}`}
                            type="submit"
                            disabled={!stripe || !clientSecret}>
                            Confirm Payment
                        </button>
                        <Link to='/dashboard'
                            className={`btn btn-sm mt-4 btn-error text-white`}
                            type="submit">
                            Cancel Payment
                        </Link>
                    </div>
                </div>
            </form>
            <p className="text-red-500">{cardError}</p>
            {
                success && <div>
                    <p className='text-green-500'>{success}</p>
                    <p>Your TransactionId: <span className='font-bold'>{transactionId}</span></p>
                </div>
            }
        </>
    );
};

export default CheckOutForm;